// src/contexts/DirtyFormFieldClassContext.tsx
import React, { createContext, useContext } from 'react';

type GetDirtyClassFunction = (fieldName: string) => string;

const DirtyFormFieldClassContext = createContext<GetDirtyClassFunction | null>(
  null
);

export const DirtyFormFieldClassProvider: React.FC<{
  getDirtyClass: GetDirtyClassFunction;
  children: React.ReactNode;
}> = ({ getDirtyClass, children }) => (
  <DirtyFormFieldClassContext.Provider value={getDirtyClass}>
    {children}
  </DirtyFormFieldClassContext.Provider>
);

export const useDirtyFormFieldClass = (): GetDirtyClassFunction => {
  const context = useContext(DirtyFormFieldClassContext);
  if (!context) {
    throw new Error(
      'useDirtyFormFieldClass must be used within a DirtyFormFieldClassProvider'
    );
  }
  return context;
};
